var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaugeChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gauge__Property 1=Gauge",
    className: "gauge__Property gauge__1=Gauge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gauge__Vector",
    className: "gauge__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919EAB",
    fillOpacity: 0.16,
    d: "M22.408 15.599c0-5.655-4.584-10.24-10.24-10.24C6.515 5.36 1.93 9.944 1.93 15.6v2.038a1 1 0 0 0 1 1h1.343a1 1 0 0 0 1-1V15.6a6.895 6.895 0 1 1 13.791 0v2.038a1 1 0 0 0 1 1h1.344a1 1 0 0 0 1-1V15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "M4.273 18.137v.5H2.93v-.5h1.343Zm17.135 0v.5h-1.344v-.5h1.344Zm.5-.5v-2.038c0-5.38-4.36-9.74-9.74-9.74-5.21 0-9.465 4.093-9.726 9.239l-.012.5v2.039a.5.5 0 0 0 .5.5v.5l-.103-.005a1 1 0 0 1-.897-.995v-2.038c0-5.655 4.584-10.24 10.239-10.24 5.655 0 10.24 4.585 10.24 10.24v2.038a1 1 0 0 1-1 1v-.5a.5.5 0 0 0 .5-.5Zm-2.844 0v-2.038a6.896 6.896 0 0 0-13.79 0v2.038a1 1 0 0 1-1 1v-.5a.5.5 0 0 0 .5-.5v-2.038a7.395 7.395 0 0 1 14.79 0v2.038a.5.5 0 0 0 .5.5v.5a1 1 0 0 1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M5.273 15.599a6.897 6.897 0 0 1 5.9-6.824c.546-.08.996-.52.996-1.072V6.36c0-.552-.45-1.005-.999-.952-5.186.503-9.24 4.874-9.24 10.192v2.038a1 1 0 0 0 1 1h1.343a1 1 0 0 0 1-1V15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01277F",
    d: "M4.273 18.137v.5H2.93v-.5h1.343Zm.5-.5v-2.038c0-3.722 2.75-6.8 6.328-7.319.345-.05.568-.316.568-.577V6.36c0-.29-.227-.475-.45-.454-4.779.463-8.548 4.38-8.779 9.222l-.01.472v2.038a.5.5 0 0 0 .5.5v.5l-.103-.005a1 1 0 0 1-.897-.995V15.6c0-5.318 4.054-9.69 9.24-10.192.55-.053.999.4.999.952v1.344c0 .552-.45.993-.997 1.072A6.897 6.897 0 0 0 5.273 15.6v2.038a1 1 0 0 1-1 1v-.5a.5.5 0 0 0 .5-.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeChart);
export default __webpack_public_path__ + "static/media/gauge_chart.7dc6f095fbfa6f1e9af5e8ec51e4beaa.svg";
export { ForwardRef as ReactComponent };